module.exports = __webpack_public_path__ + "static/media/signup1.896dd801.png";